<template>
  <div class="mt-1">
    <a-tooltip placement="top" title="Download Invoice">
      <div class="quick_action_item" @click="handleDownloadAction">
        <img class="size-5" :src="imagePath.downloadIcon" alt="email_icon" />
      </div>
    </a-tooltip>
  </div>
</template>

<script setup>
import imagePath from '@/javascript/imagePath';

const props = defineProps({
  row: { type: Object, required: true },
  action: { type: Object, required: true },
});

const emit = defineEmits(['action']);

const handleDownloadAction = () => {
  emit('action', {
    action: { id: 'download' },
    row: props.row,
  });
};
</script>
